import { Box } from "@mui/material";

const ContentPic = ({alt, image, link, isExternal, isMobile, openLatest}) => {

    const boxSx = isMobile ?
        {
            background: 'linear-gradient(to right, var(--themeCyan), var(--themeMagenta), var(--themeYellow))',
            width: '100%',
            boxSizing: 'border-box',
        } : {
            background: 'linear-gradient(to right, var(--themeCyan), var(--themeMagenta), var(--themeYellow))',
            width: '90%',
        };

    return (
        <Box 
            sx={{
                ...boxSx, display: 'flex', 
                flex: 1, 
                alignItems: 'flex-start',
                padding: '3px', 
                borderRadius: '15px'
            }}
        >
            <a 
                href={link} 
                target={isExternal ? "_blank" : undefined}
                rel={isExternal ? "noopener noreferrer" : undefined}
                onClick={(e) => {
                    if (!isExternal) {
                        e.preventDefault();
                        openLatest(); 
                    }
                }}
                style={{
                    display: 'block',
                    width: '100%',
                    borderRadius: '15px',
                    overflow: 'hidden',
                }}
            >
                <img
                    src={image}
                    alt={alt}
                    className='article-img'
                    style={{ 
                        display: 'block',
                        width: '100%',  
                        height: 'auto',
                        borderRadius: '15px',
                        aspectRatio: '16 / 9',
                        objectFit: 'fill',
                    }}
                />
            </a>
        </Box>
    );
};

export default ContentPic;